/**
 * <collection-toolbar>: submits the sort form as soon as the choice
 * changes (the form still works without JavaScript via its submit button).
 */
class CollectionToolbar extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('form[data-auto-submit]').forEach((form) => {
      form.addEventListener('change', () => form.requestSubmit());
    });
  }
}

if (!customElements.get('collection-toolbar')) customElements.define('collection-toolbar', CollectionToolbar);
